import { IFetchTokensMetadata, TokenMetadataWithCurrencies } from "./balances/commonInterfacesAndEnums";
import {getHMACHeader} from './androidCallback';
import {getGCPermit} from './gcPermitService';

const getGlipTokenData =  () => {
    let glipggToken:any = localStorage.getItem('gw-glipggtoken-data');
    if(!glipggToken){
        return;
        }
    glipggToken = JSON.parse(glipggToken);
        if(!glipggToken.id){
            return;
        }
    return glipggToken;
}

const baseUrl = "https://be.namasteapis.com";
// const baseUrl = "http://127.0.0.1:4040";

async function saveUserBackend(clientIdentifier:any, signature:any, accessToken:any){
    try{
        let resp = await fetch(baseUrl + '/blockchain/v1/auth/exchange-token', {
	    method: 'POST',
	    headers: {
	        'Accept': 'application/json',
	        'Content-Type': 'application/json'
	    },
	    body: JSON.stringify({
                "signature": signature,
                "accessToken": accessToken,
                "verifier": "youtube",
                "companyId": clientIdentifier,
            })
        });
        resp = await resp.json();
        return resp
    }
    catch(e){
        return false;
    }
}

export async function fetchNFTsBackend(walletId:any) {
    let loginInformation = getGlipTokenData();
    try{
        let resp:any = await fetch(baseUrl + `/blockchain/v1/wallet-balance/list-wallet-nft-client?walletId=${walletId}&size=50`, {
	    method: 'GET',
	    headers: {
	        'Accept': 'application/json',
	        'Content-Type': 'application/json',
                'access-token': loginInformation.accessToken
	        }
        });
        resp = await resp.json();
        return resp.data
    }
    catch(e) {
        return false;
    }
}


/**
 * It fetches the NFTs metadata from the backend. The queries to get the balances from chain are done on the wallet host.
 * @param {any} walletId - The wallet ID of the user.
 */
export async function fetchNFTsMetadataBackend(walletId:any) {
    let loginInformation = getGlipTokenData();
    try{
        let resp:any = await fetch(baseUrl + `/blockchain/v1/wallet-balance/metadata-for-client?walletId=${walletId}&size=50`, {
	    method: 'GET',
	    headers: {
	        'Accept': 'application/json',
	        'Content-Type': 'application/json',
                'access-token': loginInformation.accessToken
	        }
        });
        resp = await resp.json();
        return resp.data as IFetchTokensMetadata<TokenMetadataWithCurrencies>
    }
    catch(e) {
        return false;
    }
}

// -------------------------- //


async function submitTransfer(form:any, signature:any){
    let loginInformation = getGlipTokenData();
    try{
        let resp = await fetch(baseUrl + '/blockchain/v1/token-transfer/submit/', {
	    method: 'POST',
	    headers: {
	        'Accept': 'application/json',
	        'Content-Type': 'application/json',
                'access-token': loginInformation.accessToken
	    },
	    body: JSON.stringify({
                chain:'matic',
                form:form,
                signature:signature
            })
        });
        resp = await resp.json();
        console.log(resp);
        return resp
    }
    catch(e){
        return false;
    }
}

export async function createTransfer(
    walletIdFrom:any, walletIdTo:any,
    tokenDataId:any, amount:any){
    let loginInformation = getGlipTokenData();
    try{
        let resp = await fetch(baseUrl + '/blockchain/v1/token-transfer/create', {
	    method: 'POST',
	    headers: {
	        'Accept': 'application/json',
	        'Content-Type': 'application/json',
                'access-token': loginInformation.accessToken
	    },
	    body: JSON.stringify({
                walletIdFrom:walletIdFrom,
                walletIdTo:walletIdTo,
                tokenDataId:tokenDataId,
                amount:amount
            })
        });
        resp = await resp.json();
        return resp
    }
    catch(e){
        return false;
    }
}

export async function createSellOrder(
    makerWalletId:any, takerWalletId:any,
    makeTokenDataId:any, makeAmount:any,
    takeTokenDataId:any, takeAmount:any){
    let loginInformation = getGlipTokenData();
    try{
        let resp = await fetch(baseUrl + '/blockchain/v1/market/create-sell-order', {
	    method: 'POST',
	    headers: {
	        'Accept': 'application/json',
	        'Content-Type': 'application/json',
                'access-token': loginInformation.accessToken
	    },
	    body: JSON.stringify({
                makerWalletId: makerWalletId,
                takerWalletId: takerWalletId,
                makeTokenDataId: makeTokenDataId,
                makeAmount: makeAmount,
                takeTokenDataId: takeTokenDataId,
                takeAmount: takeAmount,
                type: "DIRECT_SALE" // Hardcoded for now
            })
        });
        resp = await resp.json();
        return resp
    }
    catch(e){
        return false;
    }
}

export async function submitSellOrder(sellOrderId:any, signature:any){
    let loginInformation = getGlipTokenData();
    try{
        let resp = await fetch(baseUrl + '/blockchain/v1/market/submit-sell-order/', {
	    method: 'POST',
	    headers: {
	        'Accept': 'application/json',
	        'Content-Type': 'application/json',
                'access-token': loginInformation.accessToken
	    },
	    body: JSON.stringify({
                id: sellOrderId,
                signature:signature
            })
        });
        resp = await resp.json();
        return resp
    }
    catch(e){
        return false;
    }
}

export async function createBuyOrder(
    sellOrderId: string,
    makerWalletId:any, takerWalletId:any,
    makeTokenDataId:any, makeAmount:any,
    takeTokenDataId:any, takeAmount:any){
    let loginInformation = getGlipTokenData();

    try{

        let resp = await fetch(baseUrl + '/blockchain/v1/market/create-bid-order', {
	    method: 'POST',
	    headers: {
	        'Accept': 'application/json',
	        'Content-Type': 'application/json',
                'access-token': loginInformation.accessToken
	    },

	    body: JSON.stringify({
                sellOrderId: sellOrderId,
                makerWalletId: makerWalletId,
                takerWalletId: takerWalletId,
                makeTokenDataId: makeTokenDataId,
                makeAmount: makeAmount,
                takeTokenDataId: takeTokenDataId,
                takeAmount: takeAmount,
                // type: "DIRECT_SALE" // Hardcoded for now // Gets it from sellOrder
            })
        });
        resp = await resp.json();
        return resp
    }
    catch(e){
        return false;
    }
}

export async function submitBuyOrder(buyOrderId:any, signature:any){
    let loginInformation = getGlipTokenData();
    try{
        let resp = await fetch(baseUrl + '/blockchain/v1/market/submit-bid-order/', {
	    method: 'POST',
	    headers: {
	        'Accept': 'application/json',
	        'Content-Type': 'application/json',
                'access-token': loginInformation.accessToken
	    },
	    body: JSON.stringify({
                id: buyOrderId,
                signature:signature
            })
        });
        resp = await resp.json();
        return resp
    }
    catch(e){
        return false;
    }
}


// ---------------------------------------------------------------- //

export async function buyNFTBackend(
    signer: any,
    sellOrderId: any,
    makerWalletId:any,
    makeTokenDataId:any, makeAmount:any,
    takeTokenDataId:any, takeAmount:any){
    let resp:any = await createBuyOrder(
        sellOrderId,
        makerWalletId, makerWalletId,
        makeTokenDataId, makeAmount,
        takeTokenDataId, takeAmount);
    let data = JSON.parse(resp.data.form);

    const sig = await signer._signTypedData( data[ "domain" ], data[ "types" ], data[ "message" ] );

    await submitBuyOrder(resp.data.id, sig);

}


export async function sellNFTBackend(
    signer: any,
    makerWalletId:any,
    makeTokenDataId:any, makeAmount:any,
    takeTokenDataId:any, takeAmount:any){
    let resp:any = await createSellOrder(
        makerWalletId, makerWalletId,
        makeTokenDataId, makeAmount,
        takeTokenDataId, takeAmount);
    let data = JSON.parse(resp.data.form);
    const sig = await signer._signTypedData( data[ "domain" ], data[ "types" ], data[ "message" ] );
    await submitSellOrder(resp.data.id, sig);
}

/**
 * It transfers an NFT from one wallet to another.
 * @param {any} walletIdFrom - The wallet ID of the wallet that is sending the NFT
 * @param {any} walletIdTo - The wallet address of the recipient
 * @param {any} tokenDataId - the id of the token you want to transfer
 * @param {any} signer - The signer object that you created in the previous step.
 * @param {any} amount - the amount of tokens to transfer
 */
export async function transferNFTBackend(
    walletIdFrom:any, walletIdTo:any,
    tokenDataId:any, signer:any, amount:any){
    let resp:any = await createTransfer(
        walletIdFrom, walletIdTo, tokenDataId, amount);
    let data = JSON.parse(resp.data.form);
    const sig = await signer._signTypedData( data[ "domain" ], data[ "types" ], data[ "message" ] );
    await submitTransfer(resp.data.form, sig)
}

/**
 * It takes a clientIdentifier, accessToken, and signer, and returns a tokenData.data
 * @param {string} clientIdentifier - This is the client identifier that you get from the client.
 * @param {string} accessToken - This is the access token that you get from the frontend.
 * @param {any} signer - This is the signer object that you created in the previous step.
 * @returns The tokenData.data is being returned.
 */
export async function loginUserBackend(
    clientIdentifier: string, accessToken: string, signer:any) {
    let signature = await signer.signMessage(accessToken);
    let tokenData:any = await saveUserBackend(clientIdentifier, signature, accessToken);
    return tokenData.data;
}





export async function registerToken(chain:any, contractAddress:any){
    let loginInformation: any = getGlipTokenData();
    try{
        let resp = await fetch(baseUrl + '/blockchain/v1/watch-to-earn/currency/register-for-wallet/', {
	    method: 'POST',
	    headers: {
	        'Accept': 'application/json',
	        'Content-Type': 'application/json',
                'access-token': loginInformation.accessToken
	    },
	    body: JSON.stringify({
                chain: chain,
                contractAddress: contractAddress
            })
        });
        resp = await resp.json();
        return resp
    }
    catch(e){
        return false;
    }
}




/**
 * This function will fund a wallet with a specified amount of tokens
 * @param {number} chain - The chain ID of the blockchain you want to fund.
 * @param {string} amount - The amount of tokens you want to fund the wallet with.
 * @returns The response is a JSON object with the following fields:
 */
export async function fundWallet(chain:number, amount:string, isTestRun: boolean = false){
    let loginInformation: any = getGlipTokenData();
    const AIRDROP_FUND_URL = `/blockchain/v1/airdrop/fund/`;
    let options:any = {
	method: 'POST',
	headers: {
	    'Accept': 'application/json',
	    'Content-Type': 'application/json',
            'access-token': loginInformation.accessToken
	},
	body: JSON.stringify({
            chainId: chain,
            amount: amount,
            isTestRun: isTestRun
        })
    }
    let encryptedAnswer:any = await getHMACHeader(
        AIRDROP_FUND_URL, options);
    options.headers['hmessage'] = encryptedAnswer;
    try{
        
        let resp = await fetch(baseUrl + AIRDROP_FUND_URL, options);
        resp = await resp.json();
        return resp;
    }
    catch(e){
        return false;
    }
}



enum ChainTXStatus {
    INITIALIZED = "INITIALIZED",
    SENT = "SENT",
    RESOLVED = "RESOLVED",
    CONFIRMED = "CONFIRMED",
    FAILED = "FAILED",
}



/**
 * It polls the Namaste API every 3 seconds for 100 times to check if the transaction has been
 * confirmed or not
 * @param {string} txId - The transaction ID of the transaction you want to poll.
 * @returns A boolean value.
 */
export async function pollTxStatus(txId: string) {

    // Poll an api every 3 seconds for 100 times
    let maxPolls = 100;
    let pollInterval = 3000;

    let loginInformation: any = getGlipTokenData();
    let resp;

    for (let i = 0; i < maxPolls; i++) {
        try {
            console.log("Polling for tx status : ", i);
            resp = await fetch(baseUrl + `/blockchain/v1/transaction/info/?txId=${txId}`, {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                            'access-token': loginInformation.accessToken
                    }
            });
            resp = await resp.json();

            if(resp.data.status === ChainTXStatus.CONFIRMED) {
                return true
            }
            else if (resp.data.status === ChainTXStatus.FAILED) {
                return false;
            }
            else {
                await new Promise(r => setTimeout(r, pollInterval));
            }
        } catch (e) {
            console.log(e);
            return false;
        }
    }
    return false;
}

export enum TXNamesEnum {
    NativeTransfer = "Coins Transferred",
    ERC20Transfer = 'ERC20 Transferred',
    ERC721Transfer = 'ERC721 Transferred',
    ERC1155Transfer = 'ERC1155 Transferred',
    ContractInteractionSuccess = 'Contract Interaction Success',
    SwapTransactionSuccess = 'Swap Transaction Success',
  }

  


  export enum TXDescriptionEnum {
    NativeTransfer = "Your transfer was successful. Check wallet!",
    ERC20Transfer = 'Your coin transfer was successful. Check wallet!',
    ERC721Transfer = 'Your NFT transfer was successful. Check wallet!',
    ERC1155Transfer = 'Your NFT transfer was successful. Check wallet!',
    ContractInteractionSuccess = 'Your contract interaction was successful. Check wallet!',
    SwapTransactionSuccess = 'Your swap was confirmed. Check wallet!',
  }
  


/**
 * This function sends a transaction confirmation to the user's devices
 * @param {string} txName - The name of the transaction.
 * @param {string} txDescription - This is the description of the transaction.
 * @param {string} txHash - The transaction hash of the transaction you want to send to the user.
 * @param {string} txImage - This is the image that will be displayed in the notification.
 */
export async function sendTXConfirmationToDevices(txName:string, txDescription: string, txChainId: any, txHash: string, txImageUri:string){
    let loginInformation: any = getGlipTokenData();
    try{
        let resp = await fetch(baseUrl + '/blockchain/v1/wallet-comms/webhook-to-client/', {
	    method: 'POST',
	    headers: {
	        'Accept': 'application/json',
	        'Content-Type': 'application/json',
                'access-token': loginInformation.accessToken
	    },
	    body: JSON.stringify({
                data: {
                txName: txName,
                txDescription: txDescription,
                txChainId: txChainId,
                txHash: txHash,
                txImageUri: txImageUri
               },
               type: "TX_CONFIRMED"
            })
        });
        resp = await resp.json();
        console.log(resp);
        return resp
    }
    catch(e){
        return false;
    }
}


export async function getMudrexOffRampWidgetKeys(){
    let loginInformation: any = getGlipTokenData();
    let newBaseUrl = baseUrl;//'http://localhost:4041'
    //newBaseUrl = 'http://localhost:4041';
    try{
        let resp = await fetch(newBaseUrl + '/blockchain/v1/mudrex/off-ramp/get-widget-keys', {
	    method: 'GET',
	    headers: {
	        'Accept': 'application/json',
	        'Content-Type': 'application/json',
                'access-token': loginInformation.accessToken
	    }
        });
        resp = await resp.json();
        console.log(resp);
        return resp
    }
    catch(e){
        return false;
    }
}

export async function getCreateMudrexUserInfo(){
    let loginInformation: any = getGlipTokenData();
    let newBaseUrl = baseUrl;
    //newBaseUrl = 'http://localhost:4041';
    try{
        let resp = await fetch(newBaseUrl + '/blockchain/v1/mudrex/off-ramp/get-create-user', {
	    method: 'GET',
	    headers: {
	        'Accept': 'application/json',
	        'Content-Type': 'application/json',
                'access-token': loginInformation.accessToken
	    }
        });
        let respJson = await resp.json();
        return respJson.data.data;
    }
    catch(e){
        return false;
    }
}

export async function getConversionRate(
    {crypto, fiat, opType}:any){
    let loginInformation: any = getGlipTokenData();
    let newBaseUrl = baseUrl; //
    //newBaseUrl = 'http://localhost:4041';
    try{
        const params = new URLSearchParams({ crypto, fiat, type:opType });
        const requestUrl = newBaseUrl + '/blockchain/v1/mudrex/off-ramp/get-conversion-rate?' + params.toString();
        let resp = await fetch(requestUrl, {
	    method: 'GET',
	    headers: {
	        'Accept': 'application/json',
	        'Content-Type': 'application/json',
                'access-token': loginInformation.accessToken
	    }
        });
        let respJson = await resp.json();
        console.log('conversion rate', respJson);
        return respJson.data.conversionRate;
    }
    catch(e){
        return false;
    }
}

export async function sendOffRampRequest(
    {crypto, fiat, amount, bankId}: any){
    let loginInformation: any = getGlipTokenData();
    let newBaseUrl = baseUrl; //
    //newBaseUrl = 'http://localhost:4041';
    console.log("input params", crypto, fiat, amount, bankId);
    try{
        const params = new URLSearchParams({ crypto, fiat, amount });
        console.log(crypto, fiat, amount);
        let signature = await getGCPermit(amount);
        let data = {
            crypto,
            fiat,
            amount,
            bankId,
            signature
        };
        const requestUrl = newBaseUrl + '/blockchain/v1/mudrex/off-ramp/sell?' + params.toString();
        let resp = await fetch(requestUrl, {
	    method: 'POST',
            body: JSON.stringify(data),
	    headers: {
	        'Accept': 'application/json',
	        'Content-Type': 'application/json',
                'access-token': loginInformation.accessToken
	    }
        });
        let respJson = await resp.json();
        console.log('conversion rate', respJson);
        return respJson.data;
    }
    catch(e){
        return false;
    }
}

export async function addRazorpayFundAccount({vpaId}:any){
    let loginInformation: any = getGlipTokenData();
    let newBaseUrl = baseUrl; //
    //newBaseUrl = 'http://localhost:4041'; //
    const requestUrl = newBaseUrl + '/blockchain/v1/razorpay/payouts/create-fund-account';
    let data = {
        "vpa_id": vpaId
    };
    try{
        let resp = await fetch(requestUrl, {
	    method: 'POST',
            body: JSON.stringify(data),
	    headers: {
	        'Accept': 'application/json',
	        'Content-Type': 'application/json',
                'access-token': loginInformation.accessToken
	    }
        });
        let respJson = await resp.json();
        return respJson.data;
    }
    catch(e){
        return false;
    }
}

export async function getRazorpayVPAFundAccount({}:any){
    let loginInformation: any = getGlipTokenData();
    let newBaseUrl = baseUrl; //
    //newBaseUrl = 'http://localhost:4041'; //
    const requestUrl = newBaseUrl + '/blockchain/v1/razorpay/payouts/get-all-vpa-fund-accounts';

    try {
        let resp = await fetch(requestUrl, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'access-token': loginInformation.accessToken
            }
        });
        
        let respJson = await resp.json();
        if (respJson.data) {
            if (typeof respJson.data === 'object' && respJson.data.fundAccounts !== undefined) {
                return respJson.data;
            }
        }
        console.log('Data not in expected format or not present');
        return false;

    } catch (e) {
        console.log('fundAccounts', e);
        return [];
    }
}

export async function sendRazorpayOfframpRequest({
    amount, razorpayFundAccountId}:any){
    let loginInformation: any = getGlipTokenData();
    let newBaseUrl = baseUrl; //
    //newBaseUrl = 'http://localhost:4041'; //
    const requestUrl = newBaseUrl + '/blockchain/v1/razorpay/payouts/offramp';
    let signature = await getGCPermit(amount);
    let data = {
        signature,
        amount,
        razorpayFundAccountId
    }
    try{
        let resp = await fetch(requestUrl, {
	    method: 'POST',
            body: JSON.stringify(data),
	    headers: {
	        'Accept': 'application/json',
	        'Content-Type': 'application/json',
                'access-token': loginInformation.accessToken
	    }
        });
        let respJson = await resp.json();
        if(!respJson.data){
            return false;
        }
        return respJson.data;
    }
    catch(e){
        console.log('fundAccounts', e)
        return false;
    }
}

export async function getRazorpayOrder({productId, payment_for}:any){
    let loginInformation: any = getGlipTokenData();
    let newBaseUrl = baseUrl; //
    //newBaseUrl = 'http://localhost:4041'; //
    const requestUrl = newBaseUrl + '/blockchain/v1/games/btx/start-razorpay-order';
    let data = {productId, payment_for};
    try{
        let resp = await fetch(requestUrl, {
	    method: 'POST',
            body: JSON.stringify(data),
	    headers: {
	        'Accept': 'application/json',
	        'Content-Type': 'application/json',
                'access-token': loginInformation.accessToken
	    }
        });
        let respJson = await resp.json();
        if(!respJson.data){
            return false;
        }
        return respJson.data;
    }
    catch(e){
        console.log('fundAccounts', e)
        return false;
    }
}


export async function getHypervergeKey({}:any){
    let loginInformation: any = getGlipTokenData();
    let newBaseUrl = baseUrl; //
    //newBaseUrl = 'http://localhost:4041'; //
    const requestUrl = newBaseUrl + '/blockchain/v1/razorpay/payouts/get-hyperverge-key';
    try{
        let resp = await fetch(requestUrl, {
	    method: 'POST',
	    headers: {
	        'Accept': 'application/json',
	        'Content-Type': 'application/json',
                'access-token': loginInformation.accessToken
	    }
        });
        let respJson = await resp.json();
        if(!respJson.data){
            return false;
        }
        return respJson.data;
    }
    catch(e){
        console.log('fundAccounts', e)
        return [];
    }
}


export async function getSetUserId({}:any){
    let loginInformation: any = getGlipTokenData();
    let newBaseUrl = baseUrl; //
    const requestUrl = newBaseUrl + '/blockchain/v1/glip/wallet/user';
    try{
        let resp = await fetch(requestUrl, {
	    method: 'GET',
	    headers: {
	        'Accept': 'application/json',
	        'Content-Type': 'application/json',
                'access-token': loginInformation.accessToken
	    }
        });
        let respJson = await resp.json();
        if(!respJson.data){
            return false;
        }
        //need to save in localstorage
        console.log('respJson.data', respJson.data);
        localStorage.setItem('glipUserId', respJson.data)
        return respJson.data;
    }
    catch(e){
        console.log('userId', e)
        return [];
    }
}

export async function updateHypervergeStatus({}:any){
    let loginInformation: any = getGlipTokenData();
    let newBaseUrl = baseUrl; //
    //newBaseUrl = 'http://localhost:4041'; //
    const requestUrl = newBaseUrl + '/blockchain/v1/razorpay/payouts/update-hyperverge-status';
    try{
        let resp = await fetch(requestUrl, {
	    method: 'POST',
	    headers: {
	        'Accept': 'application/json',
	        'Content-Type': 'application/json',
                'access-token': loginInformation.accessToken
	    }
        });
        let respJson = await resp.json();
        console.log(respJson.data);
        if(!respJson.data){
            return false;
        }
        return respJson.data.kycStatus;
    }
    catch(e){
        console.log('fundAccounts', e)
        return [];
    }
}


export async function savePanNumber({panNumber}:any){
    let loginInformation: any = getGlipTokenData();
    let newBaseUrl = baseUrl; //
    //newBaseUrl = 'http://localhost:4041'; //
    const requestUrl = newBaseUrl + '/blockchain/v1/razorpay/payouts/save-pan-number/?panNumber='+panNumber;
    try{
        let resp = await fetch(requestUrl, {
	    method: 'POST',
	    headers: {
	        'Accept': 'application/json',
	        'Content-Type': 'application/json',
                'access-token': loginInformation.accessToken
	    }
        });
        let respJson = await resp.json();
        console.log(respJson.data);
        if(!respJson.data){
            return false;
        }
        return respJson.data.kycStatus;
    }
    catch(e){
        console.log('fundAccounts', e)
        return [];
    }
}


/**
 * Fetches transfer history for Sky Mavis (Ronin) blockchain
 * @param {string} [walletAddress] - Optional wallet address to fetch transfers for. If not provided, gets from localStorage
 * @returns {Promise<TransferResponse[]>} Array of transfers or false if request fails
 */
export async function fetchSkyMavisTransfers(walletAddress?: string) {
    let loginInformation = getGlipTokenData();
    
    // If no wallet address provided, get from localStorage
    if (!walletAddress) {
        const walletId = JSON.parse(localStorage.getItem('gw-wallet-info') || '{}');
        walletAddress = walletId.address;
    }

    // Check if we have a valid address
    if (!walletAddress) {
        console.log('No wallet address available');
        return false;
    }
    let tempUrl = baseUrl;
    try {
        let resp: any = await fetch(
            tempUrl + `/blockchain/v1/skymavis/transfers-list?walletAddress=${walletAddress}`, 
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'access-token': loginInformation.accessToken
                }
            }
        );
        
        resp = await resp.json();
        
        // Check if response has data and transfers
        if (resp.data && resp.data.transfers) {
            return resp.data.transfers;
        }
        return [];
        
    } catch(e) {
        console.log('Error fetching Sky Mavis transfers:', e);
        return false;
    }
}


/**
 * Fetches NFTs from Sky Mavis backend
 * @param {string} [walletAddress] Optional wallet address to fetch NFTs for
 * @returns {Promise<any>} Raw NFT data from backend
 */
export async function fetchSkyMavisNFTsBackend(walletAddress?: string) {
    const loginInformation = getGlipTokenData();
    
    // Get wallet address from localStorage if not provided
    if (!walletAddress) {
        const walletInfo = JSON.parse(localStorage.getItem('gw-wallet-info') || '{}');
        walletAddress = walletInfo.address;
    }

    if (!walletAddress) {
        console.log('No wallet address available');
        return null;
    }

    // const baseUrl = "http://localhost:4041";
    try {
        const response = await fetch(
            `${baseUrl}/blockchain/v1/skymavis/nfts-list?walletAddress=${walletAddress}`,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'access-token': loginInformation.accessToken
                }
            }
        );

        const data = await response.json();
        
        if (!data.success) {
            console.log('Failed to fetch Sky Mavis NFTs:', data.message);
            return null;
        }

        return data;

    } catch (error) {
        console.error('Error fetching Sky Mavis NFTs from backend:', error);
        return null;
    }
}
